// extracted by mini-css-extract-plugin
export var blink = "_a9-2";
export var cursor = "_a9-1";
export var reactMarkdown = "_a9-3";
export var streamingText = "_a9-0";